const POPOVER_WELLS = "popovers.POPOVER_WELLS"
export default POPOVER_WELLS
